module.exports = __webpack_public_path__ + "static/img/result_ls_desk.b461865.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_ls_desk.jpg
// module id = SQBR
// module chunks = 3